import Intercom from '@intercom/messenger-js-sdk';
import { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import env from '../src/env/env.json';
import FormulaireCU from '../src/pages/FormulaireCU';
import './App.css';
import InfoPopupCards from './components/InfoPopupCards';

Intercom({
  api_base: 'https://api-iam.intercom.io',
  app_id: 'l4blokpb',
  region: 'eu',
});

function App({ x_id_submit }) {
  caches.keys().then((names) => {
    names.forEach((name) => {
      caches.delete(name);
    });
  });
  // alert("Complete Cache Cleared");
  // ** toujours renommer le fichier image en logo-ville.png toujours avec les même dimensions et le placer dans le dossier img */
  const logo = env.logo;

  const [popupVisible, setPopupVisible] = useState(false);

  const togglePopup = () => {
    setPopupVisible(!popupVisible);
  };

  return (
    <>
      {/* <Alerte /> */}
      <div className="App d-flex flex-column align-items-center justify-content-center position-relative">
        {/*<div className='mb-5'>*/}
        {/*  <img className="logo" src={logo} alt="logo ville" width={150}/>*/}
        {/*</div>*/}
        <FormulaireCU x_id_submit={x_id_submit} />
        <InfoPopupCards />
        <ToastContainer
          position={toast.POSITION.BOTTOM_CENTER}
          theme="colored"
        />
      </div>
    </>
  );
}

export default App;
